import PropTypes from 'prop-types'

import TagChip, {tagChipSizes as tagSizes} from '@adv-mt/mt-tag-chip'

import {TAG_CHIPS_CLASS} from '../config.js'

const GalleryBasicTags = ({tags}) => {
  return (
    <ul className={TAG_CHIPS_CLASS}>
      {tags.map(({icon: Icon, label, size = tagSizes.SMALL, type}) => {
        const hasIcon = Boolean(Icon)
        return <TagChip icon={hasIcon && <Icon />} key={label} label={label} size={size} type={type} />
      })}
    </ul>
  )
}

GalleryBasicTags.displayName = 'GalleryBasicTags'
GalleryBasicTags.propTypes = {
  tags: PropTypes.array
}

export default GalleryBasicTags
